import React from "react";

export default function Roboticist(props) {
  const theme = props.theme;
  return (
    <svg
      id="ade8c9af-7e2e-4eda-b5c8-b06129257226"
      width="100%"
      height="100%"
      viewBox="0 0 776.06371 755.2279"
    >
      <polygon
        points="516.326 380.047 516.326 565.042 547.27 615.472 549.625 619.308 671.722 619.308 674.189 380.047 516.326 380.047"
        fill="#e6e6e6"
      />
      <polygon
        points="516.326 380.047 516.326 565.042 547.27 615.472 549.169 380.047 516.326 380.047"
        opacity="0.1"
      />
      <polygon
        points="221.566 375.113 221.566 560.109 190.622 610.539 188.267 614.374 66.17 614.374 63.703 375.113 221.566 375.113"
        fill="#e6e6e6"
      />
      <polygon
        points="221.566 375.113 221.566 560.109 190.622 610.539 188.723 375.113 221.566 375.113"
        opacity="0.1"
      />
      <polygon
        points="711.188 371.414 711.188 382.513 47.67 382.513 47.67 366.48 109.335 334.414 656.923 334.414 711.188 371.414"
        fill="#e6e6e6"
      />
      <polygon
        points="711.188 371.414 711.188 382.513 47.67 382.513 47.67 366.48 711.188 371.414"
        opacity="0.1"
      />
      <polygon
        points="142.635 426.912 113.035 426.912 100.702 418.279 156.201 418.279 142.635 426.912"
        fill="#3f3d56"
      />
      <polygon
        points="142.635 462.678 113.035 462.678 100.702 454.045 156.201 454.045 142.635 462.678"
        fill="#3f3d56"
      />
      <polygon
        points="142.635 513.244 113.035 513.244 100.702 504.61 156.201 504.61 142.635 513.244"
        fill="#3f3d56"
      />
      <polygon
        points="142.635 563.809 113.035 563.809 100.702 555.176 156.201 555.176 142.635 563.809"
        fill="#3f3d56"
      />
      <polygon
        points="595.257 431.845 624.857 431.845 637.19 423.212 581.691 423.212 595.257 431.845"
        fill="#3f3d56"
      />
      <polygon
        points="595.257 467.611 624.857 467.611 637.19 458.978 581.691 458.978 595.257 467.611"
        fill="#3f3d56"
      />
      <polygon
        points="595.257 518.177 624.857 518.177 637.19 509.544 581.691 509.544 595.257 518.177"
        fill="#3f3d56"
      />
      <polygon
        points="595.257 568.742 624.857 568.742 637.19 560.109 581.691 560.109 595.257 568.742"
        fill="#3f3d56"
      />
      <path
        d="M615.414,120.456H366.228a9.422,9.422,0,0,0-9.423,9.422v167.86a9.422,9.422,0,0,0,9.421,9.424h94.6l-3.544,22.626s-20.252,10.759-6.012,11.076,81.328,0,81.328,0,12.974,0-7.595-11.392l-3.334-22.31h93.75a9.424,9.424,0,0,0,9.424-9.422V129.88a9.424,9.424,0,0,0-9.422-9.424Z"
        transform="translate(0 0.029)"
        fill="#3f3d56"
      />
      <rect
        x="365.823"
        y="130.453"
        width="249.996"
        height="139.871"
        fill="#f2f2f2"
      />
      <circle cx="490.821" cy="126.023" r="1.582" fill="#f2f2f2" />
      <circle cx="490.821" cy="294.374" r="6.013" fill="#f2f2f2" />
      <polygon
        points="481.452 357.981 481.452 361.146 311.202 361.146 311.202 358.614 311.436 357.981 315.632 346.589 477.971 346.589 481.452 357.981"
        fill="#3f3d56"
      />
      <path
        d="M546.97,354.854c-.311,1.326-1.481,2.725-4.127,4.047-9.493,4.747-28.8-1.265-28.8-1.265s-14.873-2.532-14.873-9.177a11.884,11.884,0,0,1,1.3-.776c3.991-2.111,17.225-7.322,40.69.221a9.779,9.779,0,0,1,4.46,2.923A4.666,4.666,0,0,1,546.97,354.854Z"
        transform="translate(0 0.029)"
        fill="#3f3d56"
      />
      <path
        d="M546.97,354.854c-11.62,4.452-21.978,4.785-32.607-2.6a23.342,23.342,0,0,0-13.886-4.573c3.991-2.111,17.225-7.322,40.69.221a9.78,9.78,0,0,1,4.461,2.923A4.668,4.668,0,0,1,546.97,354.854Z"
        transform="translate(0 0.029)"
        opacity="0.1"
      />
      <ellipse cx="532.4" cy="351.019" rx="4.114" ry="1.266" fill="#f2f2f2" />
      <polygon
        points="481.452 357.981 481.452 361.146 311.202 361.146 311.202 358.614 311.436 357.981 481.452 357.981"
        opacity="0.1"
      />
      <path
        d="M94.661,0A8.558,8.558,0,0,0,89.7,1.108c-1.476,1.011-2.406,2.782-3.356,4.43A52.979,52.979,0,0,1,71.91,21.843C67.621,24.985,62.168,28.9,62.9,34.7a17.365,17.365,0,0,0,2.091,5.426c3.956,7.987,14.753,14.159,13.691,23.273,3.931-6.581-1.327-9.835,2.6-16.416,1.872-3.134,5.124-6.672,7.951-4.7.946.659,1.568,1.841,2.553,2.42,2.351,1.379,4.853-1.258,6.934-3.127,7.177-6.442,17.383-4.755,26.314-2.747,4.216.948,8.847,2.191,11.339,6.221,3.277,5.3-3.113,11.02-4.728,17.01a3.262,3.262,0,0,0,3.5,4.062c2.68-.264,5.854-.481,6.013-1.657,3.372.12,7.5-.262,8.947-3.772a14.759,14.759,0,0,0,.693-4.293c.53-5.9,3.033-11.278,4.691-16.89s2.379-12.191-.419-17.167a19.882,19.882,0,0,0-3.666-4.456C135.534,2.512,114.657-.023,94.661,0Z"
        transform="translate(0 0.029)"
        fill="#2f2e41"
      />
      <path
        d="M82.138,74.905s3.453,28.779-9.209,31.081S84.44,147.427,84.44,147.427L142,154.334l-13.814-46.046s-9.209-3.453-3.453-26.476S82.138,74.905,82.138,74.905Z"
        transform="translate(0 0.029)"
        fill="#ffb8b8"
      />
      <polygon
        points="47.028 569.347 51.633 632.66 75.806 632.66 68.9 569.347 47.028 569.347"
        fill="#ffb8b8"
      />
      <polygon
        points="224.303 449.629 227.756 502.581 254.233 491.07 243.872 447.327 224.303 449.629"
        fill="#ffb8b8"
      />
      <path
        d="M29.761,327.58s1.151,66.765,8.058,88.637,5.756,23.023,4.6,26.476-2.3,1.151-2.3,6.907-2.3,96.695,0,104.753-6.907,21.872,0,23.023,39.139,0,40.29-6.907-9.209-9.209-4.6-13.813,11.511-99,11.511-99l16.116-65.615,29.929-34.534h63.313l19.569,75.975s-8.058,21.872-2.3,21.872,40.29,6.906,40.29-18.418-11.512-100.149-13.814-102.452,1.151-10.36-2.3-13.813-43.743-27.627-58.708-32.232-35.958-10.085-35.958-10.085Z"
        transform="translate(0 0.029)"
        fill="#2f2e41"
      />
      <path
        d="M254.233,481.832s-17.267-5.756-25.325,11.511-4.6,21.872-4.6,21.872,26.476,9.209,31.081,4.6c2-2,8.364-2.7,14.912-2.846,9.973-.224,12.627-14.333,3.208-17.619-.281-.1-.566-.183-.853-.255C263.442,496.8,254.233,481.832,254.233,481.832Z"
        transform="translate(0 0.029)"
        fill="#2f2e41"
      />
      <circle cx="108.038" cy="59.393" r="34.534" fill="#ffb8b8" />
      <path
        d="M63.144,120.375s56.406,11.511,70.219-6.907,19.57,51.8,19.57,51.8l6.906,73.673-10.36,40.29s-54.1,43.743-71.37,47.2-43.743,5.756-43.743,5.756,8.058-127.776,8.058-130.078S63.144,120.375,63.144,120.375Z"
        transform="translate(0 0.029)"
        fill={theme.accentColor}
      />
      <path
        d="M80.3,98.786s-12.55-7.189-16-.283S28.61,122.677,25.156,122.677s6.907,95.545,2.3,107.056S.983,325.277,13.645,332.184s3.453-6.907,16.116,10.36,74.824,17.267,78.277,10.361S80.411,294.2,86.167,245.849s14.964-115.114,6.907-124.323S80.3,98.786,80.3,98.786Z"
        transform="translate(0 0.029)"
        fill="#2f2e41"
      />
      <path
        d="M121.852,106.561l1.6-5.518s47.9,15.879,50.2,26.239,1.151,82.882-6.907,88.637-19.569,14.965-11.511,28.779,17.267,28.778,24.174,29.929,19.569,9.209,16.116,17.267-44.9-6.907-44.9-6.907S123,264.267,124.154,232.035,121.852,106.561,121.852,106.561Z"
        transform="translate(0 0.029)"
        fill="#2f2e41"
      />
      <path
        d="M162.142,242.4l-27.628,51.8s-40.289,41.441-17.267,46.045,35.686-37.987,35.686-37.987l29.929-42.592Z"
        transform="translate(0 0.029)"
        fill="#ffb8b8"
      />
      <path
        d="M96.344,9.036a7.842,7.842,0,0,0-4.039.783,9.419,9.419,0,0,0-2.732,3.131,39.753,39.753,0,0,1-11.75,11.524c-3.491,2.221-7.93,4.99-7.333,9.084a11.387,11.387,0,0,0,1.7,3.835,30.159,30.159,0,0,1,3.665,18.8l9.6-13.954c1.523-2.216,4.171-4.716,6.472-3.325.77.466,1.276,1.3,2.078,1.71,1.914.975,3.95-.889,5.644-2.21,5.843-4.553,14.151-3.36,21.421-1.942,3.432.67,7.2,1.549,9.231,4.4,3.372,4.733-.149,11.572,1.819,17.04a5.019,5.019,0,0,0,2.078-3.317c2.745.085,6.108-.185,7.284-2.666a9.225,9.225,0,0,0,.564-3.035c.431-4.168,2.469-7.97,3.818-11.937s1.937-8.617-.341-12.134a14.668,14.668,0,0,0-2.984-3.149C129.616,10.811,112.621,9.02,96.344,9.036Z"
        transform="translate(0 0.029)"
        fill="#2f2e41"
      />
      <path
        d="M162.142,122.677l10.725,2.847s24.96,63.919,19.2,107.662-9.209,34.535-9.209,34.535S173.653,247,152.933,251.605Z"
        transform="translate(0 0.029)"
        fill="#2f2e41"
      />
      <path
        d="M48.623,624.263c-2.776,3.773-2.219,9.165-4.678,13.151-2.132,3.455-6.149,5.267-8.815,8.329A22.275,22.275,0,0,0,32.864,649c-2.473,4.142-4.483,9.451-2.048,13.616,1.96,3.35,6.078,4.66,9.855,5.552,4.775,1.128,9.735,2.031,14.564,1.169s9.549-3.819,11.271-8.413a32.216,32.216,0,0,1,1.2-3.4c2.617-5.153,10.827-5.209,13.506-10.33,1.875-3.584.151-7.917-1.571-11.576l-5.261-11.177c-1.746-3.709-8.824-1.576-12.514-2.465C57.059,620.82,52.085,619.543,48.623,624.263Z"
        transform="translate(0 0.029)"
        fill="#2f2e41"
      />
      <path
        d="M10.192,265.418l48.347,74.824s29.93,37.988,39.139,20.721-32.232-46.046-32.232-46.046L34.366,257.36Z"
        transform="translate(0 0.029)"
        fill="#ffb8b8"
      />
      <path
        d="M34.366,124.98l-9.21-2.3s-18.418,5.756-23.022,29.93-1.151,120.869,4.6,122.02S35.166,257.791,38.8,261.6s-7.883-15.755-4.429-26.115S34.366,124.98,34.366,124.98Z"
        transform="translate(0 0.029)"
        fill="#2f2e41"
      />
      <g id="f3c2397c-d780-4cc6-97d8-1503d8277a2c">
        <rect
          id="ad41612f-86f7-46b2-a964-3a5da7bcf3cf"
          x="437.407"
          y="176.391"
          width="29.752"
          height="7.163"
          fill={theme.accentColor}
        />
        <rect
          id="b9a0b375-cc2a-4c59-8850-661af54e4f62"
          x="559.722"
          y="176.391"
          width="10.468"
          height="7.163"
          fill={theme.accentColor}
        />
        <rect
          id="e174c2ab-9bc5-41ec-b37c-b06fbf8a9878"
          x="580.659"
          y="176.391"
          width="10.468"
          height="7.163"
          fill={theme.accentColor}
        />
        <rect
          id="ba2479ac-4c7d-43b4-a028-73b1e20e4002"
          x="477.628"
          y="176.391"
          width="71.075"
          height="7.163"
          fill={theme.accentColor}
        />
        <rect
          id="ac60ef86-00f2-480b-8171-28b6fdfc1958"
          x="399.941"
          y="222.673"
          width="29.752"
          height="7.163"
          fill={theme.accentColor}
        />
        <rect
          id="b3d8298d-cd65-487a-8b19-4cee946356e7"
          x="522.256"
          y="222.673"
          width="10.468"
          height="7.163"
          fill={theme.accentColor}
        />
        <rect
          id="ed27f15f-f0c4-4569-8330-a6688f8e356c"
          x="543.193"
          y="222.673"
          width="10.468"
          height="7.163"
          fill={theme.accentColor}
        />
        <rect
          id="f685c005-adaf-4d60-acda-005b037d82a6"
          x="440.162"
          y="222.673"
          width="71.075"
          height="7.163"
          fill={theme.accentColor}
        />
        <rect
          id="eca7c7fc-83f8-48ca-a588-6606db47af3f"
          x="522.807"
          y="192.369"
          width="29.752"
          height="7.163"
          fill={theme.accentColor}
        />
        <rect
          id="a71b5b2f-f8b9-481d-a301-5e3357e5fe42"
          x="563.028"
          y="192.369"
          width="29.752"
          height="7.163"
          fill={theme.accentColor}
        />
        <rect
          id="abb3a25a-f854-41fc-8391-e6ad9fbe2417"
          x="399.941"
          y="192.369"
          width="10.468"
          height="7.163"
          fill={theme.accentColor}
        />
        <rect
          id="add2b425-b775-4eb5-9c25-8c4c14f957c9"
          x="420.878"
          y="192.369"
          width="10.468"
          height="7.163"
          fill={theme.accentColor}
        />
        <rect
          id="b7159612-3b84-4b0b-a885-612eaab04c06"
          x="441.815"
          y="192.369"
          width="71.075"
          height="7.163"
          fill={theme.accentColor}
        />
        <rect
          id="edfc7301-4de5-47dc-80e2-1ae2da982d6d"
          x="461.099"
          y="207.797"
          width="29.752"
          height="7.163"
          fill={theme.accentColor}
        />
        <rect
          id="e1009f91-6275-4375-80fa-0d778e331fdc"
          x="420.878"
          y="207.797"
          width="29.752"
          height="7.163"
          fill={theme.accentColor}
        />
        <rect
          id="a060fb9f-1f1a-4862-9a69-16dd49199e18"
          x="399.941"
          y="207.797"
          width="10.468"
          height="7.163"
          fill={theme.accentColor}
        />
        <rect
          id="b6754d5f-104f-449c-b9a9-cf9ac82bf5fe"
          x="582.312"
          y="207.797"
          width="10.468"
          height="7.163"
          fill={theme.accentColor}
        />
        <rect
          id="e6ed1ccd-2cfd-450f-a339-07df3a1ee6bb"
          x="500.768"
          y="207.797"
          width="71.075"
          height="7.163"
          fill={theme.accentColor}
        />
      </g>
      <circle cx="602.916" cy="536.445" r="5.244" fill="#f2f2f2" />
      <circle cx="716.008" cy="465.95" r="38" fill="#f2f2f2" />
      <circle cx="716.008" cy="465.95" r="10" fill="#e6e6e6" />
      <path
        d="M714.181,466.135c4.212,3.436,5.5,8.852,4.712,14.082A24.455,24.455,0,0,1,710.5,494.9c-5.009,4.452-11.119,7.461-17.014,10.541a123.86,123.86,0,0,0-15.576,9.455c-18.96,13.781-33.285,33.4-41.483,55.3-8.184,21.86-10.38,46.672-4.161,69.327,3.077,11.21,9.3,23.3,20.9,27.521,9.244,3.362,21.864,1.2,26.571-8.33,5.056-10.234-2-21.737-11.085-26.818-11.778-6.585-25.847-1.773-36.441,4.893-11.663,7.339-21.038,17.871-33.215,24.448a41.731,41.731,0,0,1-17.844,5.206,44.692,44.692,0,0,1-16.909-2.613,57.265,57.265,0,0,1-27.661-21.471c-7.735-11.243-11.2-25.025-11.828-38.525-1.413-30.206,10.52-58.465,20.094-86.477a264.25,264.25,0,0,0,11.519-44.86,232.461,232.461,0,0,0,2.545-46.388c-.634-13.714-1.986-28.054-8.039-40.579-5.322-11.014-15.049-20.027-27.346-22.3a27.282,27.282,0,0,0-16.44,1.888c-1.754.8-.231,3.387,1.514,2.591,10.883-4.965,23.746-.134,31.784,7.882,9.387,9.36,12.834,23.183,14.364,35.938a225.58,225.58,0,0,1-7.968,89.993c-8.347,28.353-21.476,55.521-24.506,85.226-1.382,13.555-.672,27.567,3.661,40.565a63.363,63.363,0,0,0,20.078,29.566c8.842,7.148,19.72,12.018,31.171,12.561,12.854.609,24.127-5.122,34.1-12.745,10.681-8.165,20.508-18.239,33.447-22.817,5.9-2.087,12.617-3.06,18.673-1.052a23.431,23.431,0,0,1,12.452,10.012c2.631,4.374,3.6,9.843,1.2,14.541-2.257,4.418-6.662,6.973-11.431,7.848a22.181,22.181,0,0,1-14.724-2.5c-5.224-2.984-9.047-7.991-11.725-13.281-5.34-10.55-7.134-23.107-7.407-34.817a115.265,115.265,0,0,1,4.349-33.853,119.452,119.452,0,0,1,36.089-57.529,105.947,105.947,0,0,1,13.974-10.289c5.38-3.316,11.123-5.965,16.607-9.094,5.4-3.079,10.716-6.758,14.432-11.824a25.429,25.429,0,0,0,4.887-14.95,16.76,16.76,0,0,0-5.8-13.072c-1.483-1.211-3.618.9-2.121,2.121Z"
        transform="translate(0 0.029)"
        fill="#ccc"
      />
      <g>
        <path
          d="M486.339,340.725a85.994,85.994,0,1,1-112.53-46.12A85.991,85.991,0,0,1,486.339,340.725Zm-.6,62.48a83.981,83.981,0,1,0-107.99,49.43A84.127,84.127,0,0,0,485.739,403.205Z"
          transform="translate(0 0.029)"
          fill="#f2f2f2"
        />
        <path
          d="M491.009,373.925a83.98,83.98,0,1,1-54.7-78.72A84.127,84.127,0,0,1,491.009,373.925Z"
          transform="translate(0 0.029)"
          fill="#f2f2f2"
        />
      </g>
      <path
        d="M451.008,327.78h-88a17.5,17.5,0,0,0,0,35h88a17.5,17.5,0,1,0,0-35Z"
        transform="translate(0 0.029)"
        fill="#3f3d56"
      />
      <g>
        <path
          d="M410.019,478.865a88.057,88.057,0,0,1-3.01,176.06c-.73,0-1.45-.01-2.18-.03q-.465,0-.93-.03a88.053,88.053,0,1,1,6.12-176Z"
          transform="translate(0 0.029)"
          fill="#f2f2f2"
        />
        <path
          d="M407.009,476.925a90,90,0,1,1,0,180c-.4,0-.79,0-1.19-.02-.96,0-1.92-.03-2.87-.08a90,90,0,0,1,4.06-179.9Zm87.95,93a88.053,88.053,0,1,0-91.06,84.94q.465.03.93.03c.73.02,1.45.03,2.18.03a88.072,88.072,0,0,0,87.95-85Z"
          transform="translate(0 0.029)"
          fill="#f2f2f2"
        />
      </g>
      <path
        d="M470.175,544.755H430.841a10.334,10.334,0,0,1,0-20.667h39.334a10.334,10.334,0,0,1,0,20.667Z"
        transform="translate(0 0.029)"
        fill="#3f3d56"
      />
      <circle cx="433.464" cy="534.45" r="5.244" fill="#f2f2f2" />
      <circle cx="450.508" cy="534.45" r="5.244" fill="#f2f2f2" />
      <circle cx="467.553" cy="534.45" r="5.244" fill={theme.accentColor} />
      <path
        d="M371.019,398.78a37.5,37.5,0,0,0,72,0"
        transform="translate(0 0.029)"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
        stroke-width="10"
      />
      <circle cx="378.53" cy="344.809" r="9" fill={theme.accentColor} />
      <circle cx="434.019" cy="344.809" r="9" fill={theme.accentColor} />
      <path
        d="M486.337,340.721a86,86,0,1,0,6.67,33.2A86,86,0,0,0,486.337,340.721Zm-.6,62.48a83.981,83.981,0,1,1,5.27-29.28,83.98,83.98,0,0,1-5.27,29.28Z"
        transform="translate(0 0.029)"
        fill="#3f3d56"
      />
      <path
        d="M486.338,340.721c-.75-.11-1.51-.18-2.27-.23a83.979,83.979,0,0,1,1.67,62.71c.76-.09,1.51-.21,2.26-.35a31.5,31.5,0,0,0-1.66-62.13Z"
        transform="translate(0 0.029)"
        fill="#3f3d56"
      />
      <path
        d="M329.948,340.491c-.76.05-1.52.12-2.27.23a31.5,31.5,0,0,0-1.66,62.13c.75.14,1.5.26,2.26.35a83.984,83.984,0,0,1,1.67-62.71Z"
        transform="translate(0 0.029)"
        fill="#3f3d56"
      />
      <path
        d="M407.008,476.922a90,90,0,0,0-4.06,179.9c.95.05,1.91.08,2.87.08.4.02.79.02,1.19.02a90,90,0,1,0,0-180ZM452.7,642.1a87.467,87.467,0,0,1-45.69,12.82c-.73,0-1.451-.01-2.181-.03-.31,0-.619-.01-.929-.03a88.051,88.051,0,1,1,48.8-12.76Z"
        transform="translate(0 0.029)"
        fill="#3f3d56"
      />
      <path
        d="M452.7,642.1v2.85a24.961,24.961,0,0,1-46.88,11.95,20.918,20.918,0,0,1-.99-2.01c.73.02,1.45.03,2.18.03A87.462,87.462,0,0,0,452.7,642.1Z"
        transform="translate(0 0.029)"
        fill="#3f3d56"
      />
      <path
        d="M359.428,640.921a87.336,87.336,0,0,0,44.47,13.94,20.573,20.573,0,0,1-.95,1.96,24.971,24.971,0,0,1-46.94-11.87v-4.03Z"
        transform="translate(0 0.029)"
        fill="#3f3d56"
      />
    </svg>
  );
}
